export const generateTicketNumber = (): string => {
	const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

	// Generate today's date in YYMMDD format
	const now = new Date();
	const year = now.getFullYear().toString().slice(-2); // Last two digits of the year
	const month = String(now.getMonth() + 1).padStart(2, '0'); // Ensure two-digit month
	const day = String(now.getDate()).padStart(2, '0'); // Ensure two-digit day

	const datePart = `${year}${month}${day}`;

	// Generate a random 6-character alphanumeric string
	let randomPart = '';
	for (let i = 0; i < 6; i++) {
		randomPart += chars.charAt(Math.floor(Math.random() * chars.length));
	}

	return `T-${datePart}-${randomPart}`;
};

// Example output: T-250220-3GXF7Z
